module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lfR2v8/tc-custom/9781488067532.jpg?1726454433323",
      "alt": "This image is the cover for the book Someone Is Watching, The Echo Lake Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Someone Is Watching, The Echo Lake Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("She must remember the night she desperately wants to forget. The third pulse-pounding Echo Lake novel from the award-winning author of "), _c('i', [_vm._v("A Desperate Search")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Radio host Ellie Brannon fears the return of the monster who abducted her and two of her friends from the Ruins . . . and left her for dead. Fifteen years later, Special Agent Sam Reece reopens the cold case when new evidence comes to light about one of the victims. Ellie must trust Sam completely to have any chance of discovering the truth—especially since the gaps in her memory left them with few leads. But is someone luring Ellie into a terrifying return to the scene of the crime?"), _c('br'), _c('br'), _vm._v("From Harlequin Intrigue: Seek thrills. Solve crimes. Justice served.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Stevens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Stevens is an award-winning author of over fifty novels. Born and raised in the rural south, she now resides in Houston, Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0